import { Link } from 'react-router-dom';
import { MapPin, Mail, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A2F0A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="text-[#FFD700] font-bold text-2xl tracking-wide inline-block mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              fuDco
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              India's First Food Stock Market. Revolutionizing the way you order food.
            </p>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/_fudco_" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FFD700] transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://chat.whatsapp.com/CSDBBmMuxS4KnFXgT2a9aY" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#FFD700] transition-colors" data-testid="social-whatsapp">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/restaurant-partner" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-restaurant">
                  Partner with Us (Restaurant)
                </Link>
              </li>
              <li>
                <Link to="/delivery-partner" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-delivery">
                  Partner with Us (Delivery)
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-support">
                  Help & Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-terms">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-gray-400 hover:text-white text-sm transition-colors" data-testid="footer-link-security">
                  Security
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#FFD700] font-semibold text-lg mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#2D8B2E] flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Bhubaneswar, Odisha, India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#2D8B2E] flex-shrink-0" />
                <a href="mailto:service@fudco.in" className="text-gray-400 hover:text-white text-sm transition-colors">
                  service@fudco.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2026 Fudco. All rights reserved.
          </p>
          <p className="text-gray-400 text-sm">
            India's First Food Stock Market 🇮🇳
          </p>
        </div>
      </div>
    </footer>
  );
};
